import colorReducer from "./color";
import fileReducer from "./file";
import dayReducer from "./day";
import textReducer from "./text";
import stepReducer from "./step";
import settingReducer from "./setting";
import imageReducer from "./image";
import { combineReducers } from "redux";
import moveReducer from "./move";
import frameReducer from "./frame";

const rootReducer = combineReducers({
    color: colorReducer,
    file: fileReducer,
    day: dayReducer,
    text: textReducer,
    step: stepReducer,
    setting: settingReducer,
    image: imageReducer,
    move: moveReducer,
    frame: frameReducer
})

export default rootReducer